import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { COMPETITION_URL } from 'app/@common/constants'

export default function SelectMainHotels({...props}) {

    const myProps = {
        urlAjax: COMPETITION_URL.MAIN_HOTELS,
        placeholder: 'Select main hotel',
        icon: {icon: 'hotel'}, 
        isMulti: false,
        firstSelect: (Array.isArray(props.value) || !props.value),
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}
